const DeleteRequest = () => {
    return (
        <>
            <p>Pro smazání vašeho účtu kontaktujte naši podporu na info@lamataxi.cz</p>
        </>
    )
}

export default DeleteRequest;